<section *ngIf="processing">
    <h2>{{processingMessage}}...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
  </section>

  <section *ngIf="!processing">
    <!-- Action Buttons -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate Voucher Letter {{voucher.voucherId}}</h2>
        </div>
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
          <button type="submit" name="SubmitButton" (click)="onSubmit()" mat-raised-button color="primary" value="Save" title="Save">Save</button>
          &nbsp;&nbsp;
          <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
        </div>
      </div>
      <hr />
  </section>

<mat-dialog-content id="voucherLetterPdf">

    <Header>
        <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" 
            alt="Letter Header">
    </Header>
    <style>
        td, th {
            border: 1px solid #dddddd;
            margin-left: 5.4pt;
            padding:0in 5.4pt 0in 5.4pt
            }
        </style>
    <body style="font-family: 'Arial'; ">
        <p style='color:green; font-size:24px'>{{voucher?.applicantContactName}}<br>
        {{voucher?.applicantAddress}}<br>
        {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
        <p></p>
        <p></p>
        <p style='font-size:24px'>Greetings <span style='color:green; font-size:24px'>{{voucher?.applicantContactName}}</span></p>
       
        <p style='font-size:24px'>Thank you for completing the
        well water testing voucher application. This document contains your voucher and
        next steps.</p>

        <p style='font-size:24px'><strong>Find an accredited laboratory</strong><br>
        Choose an accredited
        laboratory from the following page of this letter. Contact the lab and arrange
        sample collection for the contaminants listed in the voucher.</p>

        <p style='font-size:24px'><strong>Present the voucher to the laboratory before {{voucherService.wildfireVoucherExpiration}}:</strong><br>
        Present the voucher with your water samples. You may choose to send by mail or deliver in person.</p>

        <p style='font-size:24px'><strong>Reminder:</strong> This voucher is not transferable. If you choose not
            to use the voucher, please contact us at <a
            href="mailto:domestic.wells@dhsoha.state.or.us"><u>domestic.wells@dhsoha.state.or.us</u></a> or call 541-952-9254. </p>
            
        <p> <span style='font-size:32px;color:red'><strong>Expiration date: {{voucherService.wildfireVoucherExpiration}}</strong></span><br>
        <strong>_ _ _ _ _ _ _ _ _ _ _ _ _
            _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _<br>
            <br>
            </strong></p>
        <strong style='font-size:24px'>Voucher</strong>
        <table border=1 cellspacing=0 cellpadding=0 width=663px 
            style='width:475.0pt;padding:0in 5.4pt 0in 5.4pt;margin-left:5.4pt;border-collapse:collapse;border:none;font-size:24px' aria-describedby="voucher">
            <tr>
                <th scope="col" width=250 valign=top style='width:164.9pt;border:solid black 1.0pt;background:black;padding:0in 5.4pt 0in 5.4pt;color:white;'>
                    Item</th>
                <th scope="col" width=413 valign=top style='width:310.1pt;border:solid black 1.0pt;border-left:none;background:black;padding:0in 5.4pt 0in 5.4pt;color:white;'>
                    Voucher Details</th>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>Client Name</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;color:green'>{{voucher?.applicantContactName}}</td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>Voucher Number</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;color:green'>{{voucher?.voucherId}}</td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>Applicant Address</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;color:green'><p>{{voucher?.applicantAddress}}<br>
                    {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p></td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>Well Address<br>
                    <span style='font-size:16px'>(If Different Than Mailing Address)</span></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;color:green'>
                    <p *ngIf="wellAddressDifferent">{{voucher?.well?.address1}}<br>
                        {{voucher?.well?.city}} {{voucher?.well?.state}} {{voucher?.well?.zip}}</p>
                </td>
            </tr>
            <tr>
                <td valign=top style='padding:0in 5.4pt 0in 5.4pt;'>Contaminants to test for:</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;color:green'>
                    <span *ngFor="let contaminant of voucher?.contaminantsTestList">{{contaminant}}<br /></span> 
                </td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;color:red'>Expiration Date</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;color:red'><strong>{{voucherService.wildfireVoucherExpiration}}</strong></td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>Total value not to exceed</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>{{voucher?.voucherMaxValue}}</strong></td>
            </tr>
        </table>
        <div style="page-break-before: always; ">

        <br /><br />
        <span style='font-size:24px'>&nbsp;&nbsp;Contracted Accredited Laboratories</span>
        <br/> <br/>
        <table border=1 cellspacing=0 cellpadding=0 width=750px align=left style='width:561.25pt;border-collapse:collapse;border:none;
            margin-left:6.75pt;margin-right:6.75pt;font-size:24px;' aria-describedby="accreditedLabs">
            <tr style='height:15.0pt'>
                <th scope="col" width=216 nowrap valign=top style='padding:0in 5.4pt 0in 5.4pt;width:161.75pt;
                    height:15.0pt'><strong>Laboratory Name</strong></th>
                <th scope="col" width=318 nowrap valign=top style='padding:0in 5.4pt 0in 5.4pt;width:238.5pt;
                    border-left:none;height:15.0pt'><strong>Address</strong></th>
                <th scope="col" width=216 nowrap valign=top style='padding:0in 5.4pt 0in 5.4pt;width:161.0pt;
                    border-left:none;height:15.0pt'><strong>Phone</strong></th>
            </tr>
            <tr style='background-color: #F2F2F2;'>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Alexin Analytical Laboratories, Inc.</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>13035 SW Pacific Hwy, Tigard, OR 97223</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>503-639-9311</td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Analytical Laboratory Group</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>361 West Fifth Ave, Eugene, OR 97401</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>541-485-8404</td>
            </tr>
            <tr style='background-color:#F2F2F2'>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Columbia Laboratories, Inc.</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>12423 NE Whitaker Way, Portland, OR 97230</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>503-254-1794</td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Edge Analytical Laboratories</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>1100 NE Circle Blvd, Ste 130, Corvallis, OR 97330</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>541-753-4946</td>
            </tr>
            <tr style='background-color:#F2F2F2'>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Edge Analytical Laboratories</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>150 SW Pioneer Ct Ste W, Wilsonville, OR 97070</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>503-682-7802</td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Edge Analytical Laboratories</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>20332 Empire Avenue, Suite F4, Bend, OR 97703</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>541-639-8425</td>
            </tr>
            <tr style='background-color:#F2F2F2'>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Neilson Research Corporation</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>245 South Grape St, Medford, OR 97501</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>541-770-5678</td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Umpqua Research Company</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>PO Box 609/626 NE Division St, Myrtle Creek, OR 97457</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>541-863-5201</td>
            </tr>
            <tr style='background-color:#F2F2F2'>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Umpqua Research Company</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>PO Box 746/419 SW 5th St, Pendleton, OR 97801</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>541-276-0385</td>
            </tr>
            <tr>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Umpqua Research Company</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>738 SE Glenwood Dr, Bend, OR 97702</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>541-312-9454</td>
            </tr>
            <tr style='background-color:#F2F2F2'>
                <td style='padding:0in 5.4pt 0in 5.4pt;'><strong>Waterlab Corp.</strong></td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>2603 12th St. SE, Salem, OR 97302</td>
                <td style='padding:0in 5.4pt 0in 5.4pt;'>503-363-0473</td>
            </tr>
        </table>
    </div>
    </body> 
</mat-dialog-content>